






















































































import Vue from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventBus } from "./event-bus.js";
import pois from "./data/pois.js";
import { detect } from "detect-browser";

export default Vue.extend({
  data: function () {
    return {
      maxVideos: 2,
      contentEnabled: false,
      videos: [
        "video-brand5g",
        "video-call",
        "video-speedtest",
        "video-city",
        "video-iphone",
        "video-vrar",
        "video-gallery",
      ],
      isMobile: null,
      isLoaded: false,
      isCompatible: true,
      showOnboarding: false,
      debugDisableMusic: false,
      location: "intro",
      pois: pois,
      resizeDebounce: null,
      contentOverride: null,
      coinStage: 1,
    };
  },
  computed: {
    showMoreInfo: function () {
      var showMoreInfo =
        this.isMobile &&
        !this.contentEnabled &&
        this.pois[this.location] &&
        this.pois[this.location].html !== undefined &&
        this.pois[this.location].html !== null;

      return showMoreInfo;
    },
  },
  created() {
    this.isMobile = window.matchMedia("(max-width: 991.9px)").matches;
    this.checkCompatibility();
    this.onresize();
  },
  mounted: function () {
    if (window.location.host.indexOf("localhost") > -1) {
      this.debugDisableMusic = true;
    }
    var self = this;
    EventBus.$on("plattar-init", () => {
      console.log("Plattar iframe initialised");
    });
    EventBus.$on("singtel-launchgame", function () {
      self.launchGame();
    });
    EventBus.$on("singtel-gallerytap", function () {
      window.open("https://www.instagram.com/singtel/");
    });

    EventBus.$on("singtel-cointap1", function () {
      self.coinTap(1);
    });
    EventBus.$on("singtel-cointap2", function () {
      self.coinTap(2);
    });
    EventBus.$on("singtel-cointap3", function () {
      self.coinTap(3);
    });

    EventBus.$on("singtel-sceneloaded", function () {
      if (!this.isLoaded) {
        self.isLoaded = true;
        self.hideVideos();
        self.changeLocation("intro", false, 10, false);
        self.setMusic("play");
        self.updateCoins();
        //wait on plattar loaders white fadeout
        setTimeout(function () {
          document.getElementById("loader").style.opacity = "0";
        }, 100);

        // wait before walking in
        setTimeout(function () {
          document.getElementById("loader").style.display = "none";
          self.changeLocation("home", false, 2500, false);
          // self.showOnboarding = true;
        }, 4000);
      }
      /* self.$root.comms.send("singtel-setrenderscale", {
        scale: window.devicePixelRatio / 1.5,
      }); */
    });

    EventBus.$on("singtel-buttongoto", function (data) {
      self.changeLocation(data.loc);
    });

    window.addEventListener("resize", this.onresize);
    window.addEventListener("orientationchange", function () {
      self.onresize();
    });
    this.onresize();

    // Setup listeners and  rebroadcasting for  events from Plattar Frame
    window.addEventListener("message", this.plattarMessage, false);
  },
  methods: {
    onresize: function () {
      var self = this;
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(function () {
        self.isMobile = window.matchMedia("(max-width: 991.9px)").matches;
        var width;
        if (self.isMobile) {
          width = window.innerWidth;
        } else {
          width = window.innerHeight * 0.5625;
        }

        document.getElementById("app-frame").style.width =
          window.innerWidth + width + "px";
        document.getElementById("st-container").style.width = width + "px";
        if (self.contentEnabled) {
          document.getElementById("plattar-frame").style.transform =
            "translateX(" + -width / 2 + "px)";
          document.getElementById("st-container").style.transform =
            "translateX(" + -width + "px)";
        } else {
          document.getElementById("plattar-frame").style.transform =
            "translateX(0px)";
          document.getElementById("st-container").style.transform =
            "translateX(0px)";
        }
        self.setCenter(pois[self.location]);
        EventBus.$emit("resize");
      }, 90);
    },
    plattarMessage: function (e) {
      // console.log(e);
      if (
        e.data.eventName &&
        e.data.eventName.includes("singtel-") &&
        (e.origin.includes("plattar.com") || e.origin.includes("plattar.space"))
      ) {
        console.log(e);
        EventBus.$emit(e.data.eventName, e.data.data);
      }
    },
    changeLocation(loc, snap = false, time = 1200, clickAudio = true) {
      //console.log(loc);
      var poi = pois[loc];
      const camClone = Object.assign([], poi.camera);
      const poiClone = Object.assign([], poi);

      if (!this.isMobile && poi.camera.wideFov !== undefined) {
        camClone.fov = poi.camera.wideFov;
      }
      camClone.time = time;
      poiClone.camera = camClone;
      poi = poiClone;

      EventBus.$emit("beforeChangeLocation", poi);
      this.buttons = poi.cameraButtons;
      this.showOnboarding = false;
      this.contentOverride = null;

      if (snap) {
        this.$root.comms.send("singtel-snapto", poi.camera);
      } else {
        this.$root.comms.send("singtel-goto", poi.camera);
      }

      this.setCenterRepeat(poi);

      if (poi.music == false) {
        this.setMusic("pause");
      } else {
        this.hideVideos([
          "video-brand5g",
          "video-call",
          "video-speedtest",
          "video-city",
          "video-vrar",
        ]);
        this.setMusic("play");
      }
      this.playVideos(poi.videos);

      this.location = loc;
      this.updateCoins(loc);
      this.setContentEnabled(
        this.pois[loc].html !== undefined && !this.isMobile,
        false
      );
      if (clickAudio) this.$root.playClick();
    },
    setContentEnabled(enabled, clickAudio = true) {
      if (clickAudio) this.$root.playClick();
      this.contentEnabled = enabled;
      this.onresize();
      if (enabled == false) {
        EventBus.$emit("contentDisabled");
        this.contentOverride = null;
      } else {
        EventBus.$emit("contentEnabled");
      }
    },
    playVideos(startVideos) {
      startVideos = startVideos.slice(0, this.maxVideos);
      // console.log(startVideos);
      //check if videos contains new videos first to avoid stutter
      var pauseVideos = this.videos.filter((vid) => !startVideos.includes(vid));

      pauseVideos.forEach((video) => {
        this.$root.comms.send("singtel-setvideo", {
          title: video,
          state: "pause",
        });
      });

      startVideos.forEach((video) => {
        this.$root.comms.send("singtel-setvideo", {
          title: video,
          state: "play",
        });
      });
    },
    checkCompatibility: function () {
      const browser = detect();
      var compatible = true;
      switch (browser && browser.name) {
        case "chrome":
          if (this.getMajorVersion(browser.version) < 75) {
            compatible = false;
          }
          break;
        case "firefox":
          if (this.getMajorVersion(browser.version) < 67) {
            compatible = false;
          }
          break;
        case "edge":
          if (this.getMajorVersion(browser.version) < 18) {
            compatible = false;
          }
          break;
        case "chromium-webview":
          break;
        case "safari":
          if (this.getMajorVersion(browser.version) < 12) {
            compatible = false;
          }
          break;
        case "samsung":
          if (this.getMajorVersion(browser.version) < 11) {
            compatible = false;
          }
          break;
        case "facebook":
        case "instagram":
        case "ios-webview":
        case "edge-ios":
        case "fxios":
        case "ios":
        default:
          compatible = true;
      }
      if (browser.os == "ios") {
        //whatever weird webview reported, assume iOS is always compatible
        compatible = true;
        this.maxVideos = 4;
      }
      if (browser.os == "android") {
        this.maxVideos = 2;
      }
      if (
        browser.os.toLowerCase().includes("mac") ||
        browser.os.toLowerCase().includes("windows")
      ) {
        this.maxVideos = 4;
      }

      this.isCompatible = compatible;
    },
    getMajorVersion(versionString) {
      var num = parseInt(versionString.slice(0, versionString.indexOf(".")));
      // console.log("Browser version is: " + num);
      if (isNaN(num)) {
        return 10000; //err on side of supporting
      }
      return num;
    },
    setCenterRepeat(poi) {
      this.setCenter(poi);
      /*
      setTimeout(() => this.setCenter(poi), 1400);
      setTimeout(() => this.setCenter(poi), 1500);
      setTimeout(() => this.setCenter(poi), 1600);
      setTimeout(() => this.setCenter(poi), 1700);
      setTimeout(() => this.setCenter(poi), 2000);
      */
    },
    launchGame() {
      //window.location.href = "firstrush.html";
      window.open("firstrush.html");
    },
    setCenter(poi) {
      //console.log("SEND SETCENTER");
      this.$root.comms.send("singtel-setcenter", poi.camera);
    },
    setMusic(state) {
      if (this.debugDisableMusic) state = "pause";
      this.$root.comms.send("singtel-setaudio", {
        title: "music",
        state: state,
      });
    },
    pauseVideos() {
      this.videos.forEach((video) => {
        this.$root.comms.send("singtel-setvideo", {
          title: video,
          state: "pause",
        });
      });
    },
    hideVideos(hideVids) {
      if (hideVids == null) {
        hideVids = this.videos;
      }
      hideVids.forEach((video) => {
        this.$root.comms.send("singtel-setvideo", {
          title: video,
          state: "hide",
        });
      });
    },
    coinTap(coin) {
      if (coin == 1 && this.location != "video") {
        // we've clicked invisible coin in video nav area
        this.changeLocation("video");
        return;
      }

      console.log("coin found " + coin);
      this.contentOverride = "Coin" + coin + "Page";
      this.setContentEnabled(true);
      this.coinStage++;
      this.updateCoins();
    },
    hideCoins() {
      this.$root.comms.send("singtel-setvisible", {
        title: "coin1",
        visible: false,
      });
      this.$root.comms.send("singtel-setvisible", {
        title: "coin2",
        visible: false,
      });
      this.$root.comms.send("singtel-setvisible", {
        title: "coin3",
        visible: false,
      });
    },
    showCoin(coin) {
      this.hideCoins();
      this.$root.comms.send("singtel-setvisible", {
        title: "coin" + coin,
        visible: true,
      });
    },
    updateCoins(loc) {
      this.hideCoins();
      if (this.coinStage == 1 && loc == "video") {
        this.showCoin(1);
      }
      if (this.coinStage == 2 && loc == "game") {
        this.showCoin(2);
      }
      if (this.coinStage == 3 && loc == "iphone12ProMax") {
        this.showCoin(3);
      }
    },
  },
});
